/** True while react-snap's crawler is rendering the page for static HTML. */
export const IS_REACT_SNAP =
    typeof navigator !== 'undefined' && /ReactSnap/i.test(navigator.userAgent);
